import {
  Box,
  Button,
  Fade,
  Grid,
  IconButton,
  LinearProgress,
  Slide,
  useTheme,
} from "@mui/material";
import logoSearch from "../../assets/logo.png";
import { Close, Searchin } from "../../icons";
import { useEffect, useState } from "react";
import { ICollectionProducts } from "../../interfaces/shopify";
import { CardProduct } from "../../components/CardProduct";
import { getSearchProducts } from "../../services/getSearchProducts";
import { Link, useNavigate } from "react-router-dom";

export const Searching = () => {
  const theme = useTheme();
  const [collection, setCollection] = useState<ICollectionProducts>();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    console.log(search);
  };
  const onReset = () => setSearch("");

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      if (!search.trim()) {
        setCollection(undefined);
        setLoading(false);
        return;
      }
      try {
        const data = await getSearchProducts(search);
        setCollection(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [search]);

  return (
    <Fade in>
      <Box>
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            backdropFilter: "saturate(180%) blur(30px)",
          }}
          zIndex={999}
          top={0}
          position="sticky"
        >
          <Slide in timeout={400}>
            <Box
              display="flex"
              alignItems="center"
              height={80}
              justifyContent="space-evenly"
              gap={{ xs: 2, md: 10 }}
              marginInline={{ xs: 2, md: 10 }}
            >
              <Link to="/">
                <Box
                  sx={{
                    display: { xs: "none", md: "flex" },
                    width: { md: 130, lg: 100 },
                    height: 40,
                  }}
                >
                  <img
                    width="100%"
                    height="100%"
                    src={logoSearch}
                    alt="logo-search"
                  />
                </Box>
              </Link>

              <Box width="100%" maxWidth={950}>
                <Box
                  position="relative"
                  padding={1}
                  className="content-input"
                  sx={{
                    borderRadius: "100vmax",
                    background: theme.palette.customColor?.main,
                    overflow: "hidden",
                  }}
                  minWidth="100%"
                  height={40}
                  display="flex"
                  justifyContent="space-between"
                  gap={1}
                  alignItems="center"
                >
                  <IconButton
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: theme.palette.customColor?.main,
                      minWidth: 40,
                      minHeight: 40,
                      borderRadius: "100vmax !important",
                    }}
                  >
                    <Searchin />
                  </IconButton>
                  <input
                    value={search}
                    autoFocus
                    style={{
                      flex: 1,
                      fontSize: 16,
                      backgroundColor: theme.palette.customColor?.main,
                      height: 40,
                      margin: 0,
                      padding: 0,
                      border: "none",
                      outline: "none",
                    }}
                    onChange={onSearch}
                    type="text"
                    className="input-search"
                    placeholder="Search"
                  />
                  {search.length > 0 && (
                    <IconButton
                      onClick={onReset}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: theme.palette.customColor?.main,
                        minWidth: 40,
                        minHeight: 40,
                        position: "absolute",
                        right: 5,
                        borderRadius: "100vmax !important",
                      }}
                    >
                      <Close />
                    </IconButton>
                  )}
                  {loading && (
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                      }}
                    >
                      <LinearProgress />
                    </Box>
                  )}
                </Box>
              </Box>
              <Button
                onClick={() => navigate(-1)}
                sx={{ fontSize: 16, color: theme.palette.secondary[600] }}
                variant="text"
                color="secondary"
                disableElevation
              >
                Cancel
              </Button>
            </Box>
          </Slide>
        </Box>
        {!loading && (
          <Fade in>
            <Grid
              spacing={{ xs: 2, md: 3 }}
              container
              mt={5}
              marginInline={{ xs: 2, md: 5 }}
            >
              {collection?.products
                .filter(
                  (p) =>
                    p?.images?.edges?.length &&
                    p.images.edges[0]?.node &&
                    p?.variants?.edges?.length &&
                    p.variants.edges[0]?.node
                )
                .map((p) => (
                  <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2 }} key={p.id}>
                    <CardProduct
                      to={`/products/${p.handle}`}
                      image={p.images.edges[0].node.url}
                      alt={p.images.edges[0].node.altText ?? ""}
                      title={p.title}
                      category={collection?.categoryTitle}
                      currency={p.variants.edges[0].node.price.currencyCode}
                      price={p.variants.edges[0].node.price.amount}
                      comparePrice={
                        p.variants.edges[0].node.compareAtPrice?.amount
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </Fade>
        )}
      </Box>
    </Fade>
  );
};
